import React, { useState, useEffect } from 'react';
import { Box, Modal, InputBase, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/material/styles';
import { tokens } from '../../theme'; // Ajusta según tu estructura
import { getProductosTejidos } from '../../services/productosTejidos.services';
import { getCategoriasAmoxarifado, getOneSubCategoriasAmoxarifado } from '../../services/amoxarifado.services';

const ModalSubCategoriasAmoxarifado = ({ open, onClose, onSelect, idCategoria, nombreCategoria }) => {
  const [subcategoria, setSubCategoria] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    { field: 'id', headerName: 'ID', flex: 0.4 },
    { field: 'subcategoria', headerName: 'Sub-Categoria', flex: 0.6, cellClassName: "name-column--cell"},
    { field: 'categoria', headerName: 'Categoría', flex: 0.4,valueGetter: () => nombreCategoria,}
  ];

    useEffect(() => {
        const fetchSubCategoria = async () => {
        if (!idCategoria) return;
    
        try {
            const response = await getOneSubCategoriasAmoxarifado(idCategoria);
            setSubCategoria(response);
            setFilteredData(response);
        } catch (error) {
            console.error('Error al obtener subcategorías:', error);
        }
      };
    
      if (open) fetchSubCategoria();
    }, [open, idCategoria]);




  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);

    const filtered = subcategoria.filter((subcategorias) =>
        subcategorias.subcategoria?.toLowerCase().includes(value.toLowerCase()) 
    );

    setFilteredData(filtered);
  };

  const handleRowClick = (params) => {
    onSelect(params.row);
    onClose();
  };

  return (
        <Modal
          open={open}
          onClose={onClose}
          aria-labelledby="modal-horario-title"
          aria-describedby="modal-horario-description"
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          BackdropProps={{
            style: { backgroundColor: "rgba(0, 0, 0, 0.5)" }, // Ajustar opacidad del fondo
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: colors.primary[600],
              paddingLeft: "10px",
              paddingTop: "5px",
              paddingRight: "10px",
              paddingBottom: "10px!important",
              zIndex: 1500,
            }}
          >
            <Box m="0px">
              <Box display="flex" justifyContent="space-between" p={2} >
                <h1 id="owner-modal-title">Buscar Sub-Categoria</h1>
                <Box
                  display="flex"
                  backgroundColor={colors.primary[400]}
                  borderRadius="3px"
                  height={"40%"}
                  width={"40%"}
                  marginTop={"3%"}
                >
                  <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Buscar" value={searchValue} onChange={handleSearchChange} />
                  <IconButton type="button" sx={{ p: 1 }}>
                    <SearchIcon />
                  </IconButton>
                </Box>
              </Box>
              <Box m="10px 0" height="70vh" width="80vh" sx={{ "& .MuiDataGrid-root": { border: "none" }, "& .MuiDataGrid-cell": { borderBottom: "none" }, "& .name-column--cell": { color: colors.greenAccent[300] }, "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[900], borderBottom: "none" }, "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] }, "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[900] }, "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` }, }}
              >
                <DataGrid
                  // checkboxSelection
                  rows={filteredData}
                  columns={columns}
                  onRowClick={handleRowClick}
                />
              </Box>
            </Box>
            {/* <Button onClick={handleRowDoubleClick} color="secondary" variant="contained" style={{ marginTop: "10px" }}>
              Seleccionar
            </Button> */}
          </Box>
        </Modal>
  );
};

export default ModalSubCategoriasAmoxarifado;